import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminProgramCodes;
export const adminProgramCodesSelector = (state: RootState) => getState(state).data;
export const adminProgramCodesIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const adminProgramCodesErrorSelector = (state: RootState) => getState(state).error;
export const adminProgramCodeActiveIdSelector = (state: RootState) => getState(state).programCodeId;
export const adminProgramCodeDetailsSelector = (state: RootState) => getState(state).programCode;
export const adminProgramCodeDetailsIsLoadingSelector = (state: RootState) =>
  getState(state).programCodeIsLoading;
export const adminProgramCodeDetailsErrorSelector = (state: RootState) =>
  getState(state).programCodeError;
export const adminProgramCodeCreatingNewSelector = (state: RootState) =>
  getState(state).isCreatingNew;
